module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.vehicle) ? _c('div', {
    staticClass: "component-vehicle-overview"
  }, [_vm._m(0), _c('div', {
    staticClass: "vehicle tabs-inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('vehicle', {
    attrs: {
      "item": _vm.vehicle,
      "type": 'vehicle-card'
    },
    on: {
      "update": _vm.loadVehicle
    }
  }), (_vm.vehicle.slot_id === null) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("Vehicle is not associated do a parking lot"), _c('create-vehicle-slot', {
    attrs: {
      "item": _vm.vehicle
    },
    on: {
      "update": _vm.loadVehicle
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "columns"
  }, [(_vm.vehicle.hardware) ? _c('vehicle-hardware', {
    attrs: {
      "item": _vm.vehicle.hardware,
      "type": 'hardware-card'
    },
    on: {
      "update": _vm.loadVehicle
    }
  }) : _c('vehicle-hardware-reveal-create', {
    staticClass: "text-center",
    attrs: {
      "item": _vm.vehicle
    },
    on: {
      "update": _vm.loadVehicle
    }
  }), _c('hr'), (_vm.vehicle && _vm.vehicle.slot_id) ? _c('SearchVehicleAvailability', {
    attrs: {
      "vehicle": _vm.vehicle,
      "selectable": false
    }
  }) : _vm._e()], 1)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-bar"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Vehicle Overview")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3508400e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/VehicleOverview.vue
// module id = 2260
// module chunks = 1